/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Err_Tournament_Cannot_Waitlist_PlayerInputs */



/**
* | output |
* | --- |
* | "Only a registered player can be moved to the waitlist" |
*
* @param {Err_Tournament_Cannot_Waitlist_PlayerInputs} inputs
* @param {{ locale?: "en" | "fr" | "es" | "pt" | "it" }} options
* @returns {LocalizedString}
*/
export const err_tournament_cannot_waitlist_player = /** @type {((inputs?: Err_Tournament_Cannot_Waitlist_PlayerInputs, options?: { locale?: "en" | "fr" | "es" | "pt" | "it" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Err_Tournament_Cannot_Waitlist_PlayerInputs, { locale?: "en" | "fr" | "es" | "pt" | "it" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Seul un joueur inscrit peut être mis sur la liste d'attente")
	if (locale === "es") return /** @type {LocalizedString} */ ("Solo un jugador inscrito puede pasar a la lista de espera")
	if (locale === "pt") return /** @type {LocalizedString} */ ("Somente um jogador inscrito pode ir para a lista de espera")
	if (locale === "it") return /** @type {LocalizedString} */ ("Solo un giocatore iscritto può essere messo in lista d'attesa")
	return /** @type {LocalizedString} */ ("Only a registered player can be moved to the waitlist")
});